import { $enum } from 'ts-enum-util'
import { IShipmentStates, ISortOrderEnum } from 'types/graphqlTypes'
import * as yup from 'yup'
import { TLoadType, TTrailerStates } from '../types'

export const CarrierTrailerFiltersSchema = yup.object({
  shipmentIds: yup.string().nullable(),
  trailerNumbers: yup.string().nullable(),
  shipperIds: yup.array(yup.string()).nullable(),
  facilities: yup.array(yup.string()).nullable(),
  pickupDate: yup.string().nullable(),
  deliveryDate: yup.string().nullable(),
  trailerStates: yup.array<TTrailerStates>().nullable(),
  shipmentStates: yup.array<IShipmentStates>().nullable(),
  sortBy: yup.string(),
  sortOrder: yup.string().oneOf($enum(ISortOrderEnum).getValues()),
  showMissingTrailers: yup.boolean(),
  loadTypes: yup.array<TLoadType>(),
})

export type TCarrierTrailerFiltersSchema = yup.InferType<typeof CarrierTrailerFiltersSchema>
